import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import HomePage from "scenes/homePage";
import LoginPage from "scenes/loginPage";
import ProfilePage from "scenes/profilePage";
import KontoPage from "scenes/kontoPage";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { themeSettings } from "./theme";
import WettbewerbPage from "scenes/wettbewerb";
import WettbewerbPostPage from "scenes/wettbewerb/PostPage";
import ErlaubnisPage from "scenes/wettbewerb/erlaubnis"
import BestaetigungPage from "scenes/wettbewerb/erlaubnis/bestaetigung"
import EventsPage from "scenes/events"
import EventDetailPage from 'scenes/events/details';
import PartnerPage from "scenes/partner"
import AGBPage from "scenes/agb"
import ImpressumPage from "scenes/impressum";
import DatenschutzPage from "scenes/datenschutz";
import KontaktPage from "scenes/kontakt";
import WerbepartnerPage from "scenes/werbepartner"
import NeuerOeffnungPage from "scenes/events/neueroeffnung";
import ZahlungPage from "scenes/partner/zahlung";
import ScrollToTop from 'utils/ScrollToTop.js';
import VerifyEmailPage from "scenes/auth/VerifyEmailPage";
import ForgotPasswordPage from "scenes/auth/ForgotPasswordPage";
import ResetPasswordPage from "scenes/auth/ResetPasswordPage";

function App() {
  const mode = useSelector((state) => state.mode);
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
  const isAuth = Boolean(useSelector((state) => state.token));

  return (
    <div className="app">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/einloggen" element={<LoginPage />} />
            <Route path="/profile/:userId" element={<ProfilePage />} />
            <Route path="/u/:username" element={<ProfilePage />} />
            <Route
              path="/konto"
              element={isAuth ? <KontoPage /> : <Navigate to="/einloggen" />}
            />
            <Route path="/auth/verifizieren" element={<VerifyEmailPage />} />
            <Route path="/auth/passwort-vergessen" element={<ForgotPasswordPage />} />
            <Route path="/auth/passwort-zuruecksetzen" element={<ResetPasswordPage />} />
            <Route path="/wettbewerb" element={<WettbewerbPage />} />
            <Route path="/wettbewerb/post/:postId" element={<WettbewerbPostPage />} />
            <Route path="/wettbewerb/erlaubnis" element={<ErlaubnisPage />} />
            <Route path="/wettbewerb/erlaubnis/bestaetigung" element={<BestaetigungPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/events/:id" element={<EventDetailPage />} />
            <Route path="/events/neueroeffnung" element={<NeuerOeffnungPage />} />
            <Route path="/werbepartner" element={<WerbepartnerPage />} />
            <Route path="/partner" element={<PartnerPage />} />
            <Route path="/partner/zahlung" element={<ZahlungPage />} />
            <Route path="/kontakt" element={<KontaktPage />} />
            <Route path="/agb" element={<AGBPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
          </Routes>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
